import { type FC, type MouseEvent } from 'react';
import { Link } from 'dibs-elements/exports/Link.tsx';
import { defineMessages, useIntl } from 'dibs-react-intl';

import classnames from 'classnames';
import dibsCss from 'dibs-css';
import styles from '../SbSharedRefineMenuInputRange/SbSharedRefineMenuInputRange.module.css';

const messages = defineMessages({
    applyLabel: {
        id: 'sb.SbSharedRefineMenuInputRangeApplyButton.applyLabel',
        defaultMessage: 'Apply range',
    },
    set: {
        id: 'sb.SbSharedRefineMenuInputRangeApplyButton.set',
        defaultMessage: 'Set',
    },
});

type Props = {
    disabled: boolean;
    hasError: boolean;
    onClick: (event: MouseEvent<HTMLElement>) => void;
};

export const SbSharedRefineMenuInputRangeApplyButton: FC<Props> = ({
    disabled,
    hasError,
    onClick,
}) => {
    const intl = useIntl();
    return (
        <Link
            ariaLabel={intl.formatMessage(messages.applyLabel)}
            className={classnames(
                styles.mlXsmall,
                dibsCss.textBodySmallHeavy,
                disabled || hasError
                    ? [styles.disabled, dibsCss.pointerEventsNone]
                    : [dibsCss.textNoir]
            )}
            onClick={onClick}
            dataTn={`input-range-apply${hasError ? '-error' : ''}`}
        >
            {intl.formatMessage(messages.set)}
        </Link>
    );
};
